module.exports = __webpack_public_path__ + "static/media/p2p.ec97d69d.svg";